import { render, staticRenderFns } from "./AreaDoAssociadoLogin.vue?vue&type=template&id=15e7e810&"
import script from "./AreaDoAssociadoLogin.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports